import React from "react";
import styles from './login.module.scss';
import logo from '../../assets/logo.svg'

const Login = ({ children, email, icon, onClick, label, ...props }) => {
  return <div {...props}>
    <div className={styles.loginPaper}>
      <div className={styles.loginIconHeader}>
        <img src={logo} height={50} alt="icon" />
      </div>
      <div className={styles.loginButtonContainer}>
        {children}
      </div>
      <div>
        Contact Us
      </div>
      <div>
        Please email us at {email}
      </div>
    </div>
  </div>;
};

export default Login